import { React, useState, useEffect } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../../../Context/LanguageContext';
import { useTheme } from '../../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../../Styles/theme';

import { ReactComponent as LeftArrowSvg } from '../../../../image/LeftArrow.svg';
import { ReactComponent as DoubleLeftArrowSvg } from '../../../../image/DoubleLeftArrow.svg';

import moment from 'moment';

export default function AttendanceCalenderBox(props) {
  const { lessonHistory } = props;
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [today, setToday] = useState(moment());
  const [isClicked, setIsClicked] = useState(false);
  const [dateList, setDateList] = useState([]);

  const firstWeek = today.clone().startOf('month').week();
  const lastWeek = today.clone().endOf('month').week() === 1 ? 53 : today.clone().endOf('month').week();

  useEffect(() => {
    let newDateList = [];

    for (let week = firstWeek; week <= lastWeek; week++) {
      for (let i = 0; i < 7; i++) {
        let days = today.clone().startOf('year').week(week).startOf('week').add(i, 'day');

        newDateList.push(days);
      }
    }
    setDateList(newDateList);
  }, [isClicked, today, firstWeek, lastWeek])

  // 출석 여부 확인 //
  function decideAttendanceState(data) {
    let isExist = false;

    for (let i = 0; i < lessonHistory.length; i++) {
      let classDate = moment(lessonHistory[i].classDate)
      if (data.format('YYYY.MM.DD') === classDate.format('YYYY.MM.DD')
        && (lessonHistory[i].status === 1 || lessonHistory[i].status === 2)
        && today.format('MM') === classDate.format('MM')) {
        isExist = true;
        break;
      }
    }

    return isExist;
  }

  return (
    <Box $isDark={isDark}>
      <TitleWrapper>
        <LayerWrapper>
          <ArrowButton onClick={() => setToday(today.clone().subtract(1, 'year'))}>
            <StyledDoubleArrow />
          </ArrowButton>
          <ArrowButton onClick={() => setToday(today.clone().subtract(1, 'month'))}>
            <StyledArrow />
          </ArrowButton>
          <Title>{today.format(t('memberDetail.calendarMonthFormat'))}</Title>
          <ArrowButton onClick={() => setToday(today.clone().add(1, 'month'))}>
            <StyledArrow isRight />
          </ArrowButton>
          <ArrowButton onClick={() => setToday(today.clone().add(1, 'year'))}>
            <StyledDoubleArrow isRight />
          </ArrowButton>
        </LayerWrapper>
        <Text fontFamily='NotoSansKR-Bold' fontSize={10} color={theme.text} cursor='default'>{t('memberDetail.attendanceStamp')}</Text>
      </TitleWrapper>
      <DateColumnWrapper>
        <DateColumn style={{ width: `21px`, marginRight: `21px` }}>SUN</DateColumn>
        <DateColumn style={{ width: `25px`, marginRight: `19px` }}>MON</DateColumn>
        <DateColumn style={{ width: `19px`, marginRight: `21px` }}>TUE</DateColumn>
        <DateColumn style={{ width: `24px`, marginRight: `18px` }}>WED</DateColumn>
        <DateColumn style={{ width: `22px`, marginRight: `22px` }}>THU</DateColumn>
        <DateColumn style={{ width: `15px`, marginRight: `22px` }}>FRI</DateColumn>
        <DateColumn style={{ width: `20px`, marginRight: `16px` }}>SAT</DateColumn>
      </DateColumnWrapper>
      <DateWrapper>
        {
          dateList.map((data, index) => (
            data.format('MM') === today.format('MM') ?
              <Date key={index} isClicked={decideAttendanceState(data)}>
                {data.format('D')}
              </Date>
              :
              <WithoutHoverDate key={index}>
                {data.format('D')}
              </WithoutHoverDate>
          ))
        }
      </DateWrapper>
    </Box>
  )
}

const Box = styled.div`
  display: flex;
  flex-direction: column;

  width: 301px;

  padding-bottom: 14px;

  border-radius: 8px;
  box-shadow: ${props => props.$isDark ? 'none' : '0px 0px 10px 0px rgba(0, 0, 0, 0.05)'};
  background-color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;
`;

const LayerWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  gap: 4px;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  margin-top: 18px;
  padding: 0px 14px 0px 14px;

  width: calc(100% - 28px);
`;

const ArrowButton = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;

  margin-top: 1px;

  width: 16px;
  height: 16px;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const StyledArrow = styled(LeftArrowSvg)`
  width: 7px;
  height: auto;
  flex-shrink: 0;

  color: ${props => props.theme.subText};
  transform: ${props => props.isRight ? 'rotate(180deg)' : 'rotate(0deg)'};
`;

const StyledDoubleArrow = styled(DoubleLeftArrowSvg)`
  width: 11px;
  height: auto;
  flex-shrink: 0;

  color: ${props => props.theme.subText};
  transform: ${props => props.isRight ? 'rotate(180deg)' : 'rotate(0deg)'};
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 12px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: default;
    }
  }
`;

const DateColumnWrapper = styled.div`
  display: flex;
  flex-direction: row;

  margin-top: 16px;
  margin-left: 14px;
  margin-bottom: 24px;
`;

const DateColumn = styled.p`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  font-family: Poppins-bold;
  font-size: 10px;

  color: ${props => props.theme.primary};

  margin: 0 0 0 0;
`;

const DateWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  width: 290px;
  margin-left: 6px;
`;

const Date = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;

  width: 23px;
  height: 23px;

  border-radius: 23px;

  margin: 7.5px 9px 7.5px 9px;

  background-color: ${props => props.isClicked ? `#FF7322` : props.theme.subBackground};

  font-family: Poppins-Medium;
  font-size: 14px;

  color: ${props => props.isClicked ? props.theme.subBackground : props.theme.subText};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const WithoutHoverDate = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;

  width: 23px;
  height: 23px;

  border-radius: 23px;

  margin: 7.5px 9px 7.5px 9px;

  background-color: ${props => props.theme.subBackground};

  font-family: Poppins-Regular;
  font-size: 14px;

  color: ${props => props.theme.line};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: default;
    }
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  padding: 0 0 0 0;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }
`;
